<template>
	<v-dialog
    v-model="dialogReporteAltasBajas.estatus"
    hide-overlay
    persistent
    max-width="1200"
  >
    <v-card>
      <v-card-title primary-title >
        <v-icon left>mdi-file</v-icon> Reporte de altas y bajas
      </v-card-title>
      <v-card-text>

        <!-- Agregar filtros por escuela -->
        <v-row>
          <v-col cols="12" md="6" lg="4">
            <!-- Radio button para escuela -->
            <v-radio-group v-model="escuelaFilter" row>
              <v-radio label="Fast"  :value="2"></v-radio>
              <v-radio label="Inbi"  :value="1"></v-radio>
              <v-radio label="Todas" :value="3"></v-radio>
            </v-radio-group>
          </v-col>

          <!-- Filtros por fechas -->
          <v-col cols="12" md="6" lg="4">
            <v-text-field label="Fecha de inicio" v-model="fechaAlta" type="date" dense filled></v-text-field>
          </v-col>
          <v-col cols="12" md="6" lg="4">
            <v-text-field label="Fecha de fin" v-model="fechaBaja" type="date" dense filled></v-text-field>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headersRezagados"
          :items="filterReporte"
          class="elevation-0"
          dense
        >

          <template v-slot:item.altas="{ item }">
            <v-chip color="green" small dark @click="dialogPersonal = true, personal = item.altas">{{ item.altas.length }}</v-chip>
          </template>

          <template v-slot:item.bajas="{ item }">
            <v-chip color="red" small dark @click="dialogPersonal = true, personal = item.bajas">{{ item.bajas.length }}</v-chip>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error"   dark @click="cerrar()">Cancelar</v-btn>
      </v-card-actions>
      <v-btn 
        color="transparent elevation-0"
        x-small
        absolute
        top
        right
        fab
        class="mt-5 mr-0"
        @click="cerrar()"
       ><v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>

    <!-- Dialog de personal -->
    <v-dialog v-model="dialogPersonal" max-width="1200">
      <v-card>
        <v-card-title>
          <v-icon left>mdi-account</v-icon> Personal
        </v-card-title>
        <v-card-text>
          <v-data-table 
            :headers="headersPersonal" 
            :items="personal" 
            class="elevation-0" 
            dense
          ></v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error"   dark @click="dialogPersonal = false">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-dialog>
</template>
<script>
  
  import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import { mapGetters, mapActions }  from 'vuex';


	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

		props:[
			'dialogReporteAltasBajas',
			'trabajadorERP',
      'planteles'
	  ],

	  computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),
    },

    data: () => ({

    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      escuelaFilter: 3,

      headersRezagados: [
        { text: 'Nombre',    value: 'id_plantel' },
        { text: 'Plantel',   value: 'plantel'    },
        { text: 'Altas',     value: 'altas'      },
        { text: 'Bajas',     value: 'bajas'      },
      ],

      headersPersonal: [
        { text: 'Id',        value: 'id_trabajador'         },
        { text: 'Nombre',    value: 'nombre_completo'       },
        { text: 'Puesto',    value: 'puesto'                },
        { text: 'Plantel',   value: 'plantel'               },
        { text: 'F. Alta',   value: 'fecha_alta'            },
        { text: 'F. Baja',   value: 'fecha_termino_labores' },
      ],

      search:'',
      fechaAlta: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechaBaja: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      dialogPersonal: false,
      personal: [],
    }),

    computed: {
      filterReporte( ){

        // Campos para filtrar por fechas de alta y bajas
        // fecha_alta "2019-05-31 15:24:09"
        // fecha_baja "2019-09-19 14:58:24"

        console.log( this.trabajadorERP )

        let planteles = this.planteles.filter( el => [1,2,3,4,'1','2','3','4'].includes( el.estado ) || el.plantel.match('CORPO') )

        if( this.escuelaFilter == 1  ){
          planteles = planteles.filter( el => !el.plantel.match('FAST') )
        }

        if( this.escuelaFilter == 2  ){
          planteles = planteles.filter( el => el.plantel.match('FAST') )
        }

        let altas = []
        let bajas = []

        for( const i in planteles){
          const { id_plantel } = planteles[i]

          altas = altas.concat( this.trabajadorERP.filter( 
            el => el.fecha_ingreso && 
            el.id_plantel == id_plantel && 
            ( el.fecha_ingreso >= this.fechaAlta && 
            el.fecha_ingreso <= this.fechaBaja ) ))
          
          bajas = bajas.concat( this.trabajadorERP.filter( 
            el => el.fecha_termino_labores && 
            el.id_plantel == id_plantel && 
            ( el.fecha_termino_labores >= this.fechaAlta && 
            el.fecha_termino_labores <= this.fechaBaja ) ))

          planteles[i].altas = this.trabajadorERP.filter( 
            el => el.fecha_ingreso && 
            el.id_plantel == id_plantel && 
            ( el.fecha_ingreso >= this.fechaAlta && 
            el.fecha_ingreso <= this.fechaBaja ) )
          
          planteles[i].bajas = this.trabajadorERP.filter( 
            el => el.fecha_termino_labores && 
            el.id_plantel == id_plantel && 
            el.fecha_termino_labores >= this.fechaAlta && 
            el.fecha_termino_labores <= this.fechaBaja )
        }

        // Agregar un total de altas y bajas
        planteles.push({
          plantel: 'Total',
          id_plantel: 0,
          altas: altas,
          bajas: bajas
        })

        return planteles
      }
    },


    methods:{
    	//Boton Basura
      rechazoProspectoBasura(idprospectos){
        if( this.getdatosUsuarioERPERP.idpuesto != 18 ){ this.validarErrorDirecto('Errorrr, no tienes permiso para actualizar esta información'); return }
        const payload = {
          idprospectos: idprospectos,
          idusuarioerp: this.getdatosUsuarioERPERP.iderp,
          notaRechazo:  'Prospecto rezagado'
        }

        // Hacer la peticion de los datos
        this.$http.post('prospectos.finalizar.nok', payload).then((response) => {
          // Ya termino de realizar su función
          for(const i in this.prospectosBasura){
            if(this.prospectosBasura[i].idprospectos == idprospectos){
              this.prospectosBasura.splice(i,1)
            }
          }

          this.dialogSuccess = true
        }).catch(error=>{
          this.validError( error )
        }).finally(()=> { this.overlay = false })
      },

      cerrar(){
      	this.dialogReporteAltasBajas.estatus = false
      	this.$emit('initialize')
      }
    }
	}
</script>
